import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'

import AppVersionOutOfDateBanner from './AppVersionOutOfDateBanner'
import DesktopAppDetectionBanner from './DesktopAppDetectionBanner'
import NotificationsBanner from './NotificationsBanner'

interface BannerManagerWrapperProps {
  show: boolean
}
const BannerManagerWrapper = styled.div<BannerManagerWrapperProps>`
  height: ${({ show }) => (show ? '56' : '0')}px;
  transition: all 200ms ease;
  z-index: 10;
`

const ChildWrapper = styled.div`
  position: absolute;
  width: 100%;
`

export interface BannerProps {
  onShowCallback: (isShown: boolean) => void
}

const BannerManager = () => {
  const defaultValues = new Array(3).fill(false) as boolean[]

  const [notificationShowStatuses, setNotificationShowStatuses] =
    useState(defaultValues)

  const shouldShow = useMemo(() => {
    return notificationShowStatuses.some((status) => status)
  }, [notificationShowStatuses])

  const setShownStatusForIndex = useCallback(
    (index: number, isShown: boolean) => {
      const newStatuses = [...notificationShowStatuses]
      newStatuses[index] = isShown
      setNotificationShowStatuses(newStatuses)
    },
    [notificationShowStatuses.length],
  )

  const handleNotificationBannerShown = useCallback(
    (isShown: boolean) => {
      setShownStatusForIndex(0, isShown)
    },
    [setShownStatusForIndex],
  )

  const handleAppVersionOutOfDateBannerShown = useCallback(
    (isShown: boolean) => {
      setShownStatusForIndex(1, isShown)
    },
    [setShownStatusForIndex],
  )

  const handleDesktopAppDetectionBannerShown = useCallback(
    (isShown: boolean) => {
      setShownStatusForIndex(2, isShown)
    },
    [setShownStatusForIndex],
  )

  return (
    <BannerManagerWrapper show={shouldShow}>
      <ChildWrapper>
        <NotificationsBanner onShowCallback={handleNotificationBannerShown} />
      </ChildWrapper>
      <ChildWrapper>
        <AppVersionOutOfDateBanner
          onShowCallback={handleAppVersionOutOfDateBannerShown}
        />
      </ChildWrapper>
      <ChildWrapper>
        <DesktopAppDetectionBanner
          onShowCallback={handleDesktopAppDetectionBannerShown}
        />
      </ChildWrapper>
    </BannerManagerWrapper>
  )
}

export default BannerManager
